export const REPORT_OFFER_MUTATION = `
  mutation ReportOfferMutation(
    $id: ID!
    $offerReportReason: OfferReportReason!
  ) {
    me {
      reportOffer(offerId: $id, reportReason: $offerReportReason) {
        id
        status
        offerReportReason
      }
    }
  }
`;
